/**
 * Analytics
 * Analytics API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MqttCommandEvent { 
    source: string | null;
    timestamp: string;
    deviceTwistId?: string | null;
    modelIndex?: number | null;
    summary?: string | null;
    deviceName?: string | null;
    modelTypeName?: string | null;
    direction?: string | null;
    command?: string | null;
    key?: number | null;
    payload?: string | null;
    type: MqttCommandEventTypeEnum;
}
export enum MqttCommandEventTypeEnum {
    MqttCommand = 'mqtt-command'
};



